/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-unused-vars
const IC_MAIN_LOGO = require('../assets/images/ic_main_logo.png');
const IC_USER_THUMB = require('../assets/images/ic_user_thumb.png');

export {
  IC_MAIN_LOGO,
  IC_USER_THUMB,
};
